import { DEFAULT_LOCALE } from '../constants/Values';

export const getUserLocale = () => {
  const userLocale = navigator.language.split('-')[0]; //eslint-disable-line
  if (userLocale === 'de' || userLocale === 'en' || userLocale === 'fr' || userLocale === 'ja') {
    return userLocale;
  }
  return DEFAULT_LOCALE;
};
